import { styled } from "@mui/material/styles";
import { HubButton } from "../inputs";
import { Stack } from "@mui/material";

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: "5px",
  padding: "3px",
  backgroundColor: theme.palette.hubColors.greyLight,
  borderRadius: "15px",
  ".HubButtonGroup-selected": {
    backgroundColor: theme.palette.hubColors.white,
    // color: theme.palette.hubColors.mainFocus,
    span: {
      fontWeight: 800,
    },
    "&:hover": {
      backgroundColor: theme.palette.hubColors.greyLightest,
    },
  },
  ".HubButtonGroup-button": {
    color: theme.palette.hubColors.greyShade,
  },
}));

export const StyledHubButton = styled(HubButton)({
  boxShadow: "none",
  padding: "3px 15px",
  fontSize: "10px",
  borderRadius: "15px",
  minWidth: "70px",
  "&:hover": {
    boxShadow: "none",
  },
});
